<template>
  <div class="content-main" :class="`content-${theme}`">
    <div class="box">
      <div
        :class="`markdown-body-${theme}`"
        @mouseenter="onMouseElement('enter')"
        @mouseleave="onMouseElement('leave')"
      >
        <Container
          :class="elements.length > 0 ? '' : boxerClassName.boxer"
          drag-class="opacity-ghost"
          drop-class="opacity-ghost-drop"
          group-name="markdown"
          non-drag-area-selector=".text-editor"
          @drop="onDropElement"
          @drag-start="onClickOutside"
          @drag-enter="onClickOutside"
          v-click-outside="vcoConfig"
        >
          <p
            :class="elements.length > 0 ? '' : boxerClassName.text"
            v-if="elements.length <= 0"
          >
            Drop your first element here!
          </p>
          <div v-if="elements.length >= 0">
            <Draggable v-for="(element, index) in elements" :key="index">
              <Element
                :element="element"
                @selectElement="setSelectedElement(index)"
                @onClick="onClickOutside"
                :selected="selectedElementIndex == index"
                @removeElement="removeElement(index)"
              />
            </Draggable>
          </div>
        </Container>
      </div>
    </div>
  </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";
import { mapActions, mapGetters } from "vuex";
import Element from "./Element.vue";

export default {
  name: "Content",
  data() {
    return {
      vcoConfig: {
        handler: this.onClickOutside,
        events: ["dblclick", "click", "drag", "dragstart"],
      },
      dragHover: false,
    };
  },
  components: { Container, Draggable, Element },
  methods: {
    onClickOutside() {
      this.setSelectedElement(null);
    },
    onMouseElement(type) {
      if (type === "enter" && this.elements.length <= 0) {
        this.dragHover = true;
      } else if (type === "leave" && this.elements.length <= 0) {
        this.dragHover = false;
      }
    },
    ...mapActions(["onDropElement", "setSelectedElement", "removeElement"]),
  },
  computed: {
    ...mapGetters(["elements", "selectedElementIndex", "theme"]),
    boxerClassName() {
      return this.dragHover
        ? {
            boxer: "boxer is-drag-over",
            text: "boxer-text is-text-drag-over",
          }
        : {
            boxer: "boxer is-drag-leave",
            text: "boxer-text is-text-drag-leave",
          };
    },
  },
};
</script>

<style lang="scss" scoped>
.content-main {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.boxer {
  outline-offset: -10px;
  height: 10em;
  position: relative;
  transition: all 0.2s ease;
}

.is-drag-over {
  background-color: white;
  outline: 2px dashed #494647;
}

.is-drag-leave {
  background-color: #494647;
  outline: 2px dashed white;
}

.boxer-text {
  font-weight: bold;
  position: absolute;
  top: 50%; /* position the top  edge of the element at the middle of the parent */
  left: 50%; /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -50%);
}

.is-text-drag-over {
  color: #494647;
}

.is-text-drag-leave {
  color: white;
}

.box {
  padding: 16px;
  border-bottom: 1px solid #30363d;
}
</style>
